<template>
    <div>
        <div class="text-center font-italic font-weight-bold titel mb-5">
            {{title.toUpperCase()}}
        </div>
        <div>
            <div class="block1 d-inline-block mr-5">
                <div class="block1a d-inline-block font-weight-bold">
                    <p class="blockLabel">LIGA:</p>
                    <p class="blockLabel">DATUM:</p>
                    <p class="blockLabel">UHRZEIT:</p>
                </div>
                <div class="block1b d-inline-block text-center font-weight-bold">
                    <p class="blockContent">{{liga}}</p>
                    <p class="blockContent">{{spiel.getDatumFormated()}}</p>
                    <p class="blockContent">{{spiel.infos.uhrzeit}}</p>
                </div>
            </div>
            <div class="block2 d-inline-block">
                <div class="block2a d-inline-block font-weight-bold">
                    <p class="blockLabel">RUNDE:</p>
                    <p class="blockLabel">ORT:</p>
                    <p class="blockLabel">BAHN:</p>
                </div>
                <div class="block2b d-inline-block text-center font-weight-bold">
                    <p class="blockContent">
                        <span v-if="spiel.saison.rundeText">{{spiel.saison.rundeText}}</span>
                        <span v-else-if="spiel.saison.semester==='A'">{{spiel.saison.runde}}</span>
                        <span v-else>{{spiel.saison.runde}} {{spiel.saison.semester}}</span>
                    </p>
                    <p class="blockContent">{{spiel.infos.ort}}</p>
                    <p class="blockContent">{{spiel.infos.bahn}}</p>
                </div>
            </div>
            <div class="d-inline-block ml-5">
                <img width="90" src="../../../../assets/oeskb.png">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "spiel-bericht-print-header",
        props: ['spiel', 'liga', 'title'],

    }
</script>

<style scoped>
    .titel { font-size: 24px }
    .blockLabel {border-bottom: solid 1px white; height: 18px}
    .blockContent {border-bottom: dotted 1px black; height: 18px}
    .block1 { width: 7cm; font-size: 13px }
    .block1a { width: 2.2cm }
    .block1b { width: 4.8cm }
    .block2 { width: 8cm; font-size: 13px }
    .block2a { width: 1.8cm }
    .block2b { width: 6.2cm }
</style>